export const getQueryParameter = (parameterName: string) => {
  const params = (new URL(document.location.href)).searchParams
  return params.get(parameterName)
}
